import { render } from "./TrashEmail.vue?vue&type=template&id=5e406b46&scoped=true"
import script from "./TrashEmail.vue?vue&type=script&lang=js"
export * from "./TrashEmail.vue?vue&type=script&lang=js"

import "./TrashEmail.vue?vue&type=style&index=0&id=5e406b46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e406b46"]])

export default __exports__